import React from "react";
import "./styles.css";

const GroupAllUsers = ({ description }) => {
    return (
        <div className="userTag allUsers">
            <p>{description ? description : "ALL USERS"}</p>
        </div>
    );
};

export default GroupAllUsers;